import React from 'react'
import CssBaseline from '@material-ui/core/CssBaseline'
import Menu from './menu'
import MenuWithoutLogin from './menuWithoutLogin'
import ErrorSnackbar from './error'
import { Route, Redirect } from 'react-router-dom'

const withLayout = (Component) => {

  const token = localStorage.getItem('token');
  return () => (
    < React.Fragment >
      {
        (token) ?
          <Route
            render={({ location }) => (
              <Redirect
                to={{
                  pathname: "/dashboard",
                  state: { from: location }
                }}
              />
            )
            }
          />
          :
          <div>
            <CssBaseline />
            {token ?
              <Menu>
                <ErrorSnackbar>
                  <Component />
                </ErrorSnackbar>
              </Menu>
              : <MenuWithoutLogin>
                <ErrorSnackbar>
                  <Component />
                </ErrorSnackbar>
              </MenuWithoutLogin>
            }
          </div>
      }
    </React.Fragment >
  )
}

export default withLayout